import { render, staticRenderFns } from "./AccelerationViz.vue?vue&type=template&id=680ab998&scoped=true"
import script from "./AccelerationViz.vue?vue&type=script&lang=js"
export * from "./AccelerationViz.vue?vue&type=script&lang=js"
import style0 from "./AccelerationViz.vue?vue&type=style&index=0&id=680ab998&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680ab998",
  null
  
)

export default component.exports